import TripleStateSwitch from '../../../../../../../Shared/TripleStateSwitch/TripleStateSwitch';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../../../../context';

const NeedsReviewFilterSwitch = () => {
    const dispatch = useDispatch();
    const currentNeedsReviewFilterValue = useSelector(
        (state) => state.daylight.codeNeedsReviewFilter
    );

    const needsReviewProps = {
        defaultState: getDefaultState(currentNeedsReviewFilterValue),
        states: {
            falseState: {
                title: 'No',
                onClick: () =>
                    dispatch(actions.daylight.setCodeNeedsReviewFilter(false)),
            },
            neutralState: {
                title: 'Both',
                onClick: () =>
                    dispatch(actions.daylight.setCodeNeedsReviewFilter(null)),
            },
            trueState: {
                title: 'Yes',
                onClick: () =>
                    dispatch(actions.daylight.setCodeNeedsReviewFilter(true)),
            },
        },
    };

    return (
        <div className="d-flex justify-content-between align-items-center">
            <span>Show Needs Review</span>
            <TripleStateSwitch {...needsReviewProps} />
        </div>
    );
};

const getDefaultState = (needsReviewFilterValue) => {
    if (needsReviewFilterValue === null) {
        return 'neutral';
    }
    return needsReviewFilterValue.toString();
};

export default NeedsReviewFilterSwitch;
